import _ from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  search,
  get,
  add,
  update,
  getMine,
} from "../../modules/timeClockPermission";

const apiBase = "timeClockPermission";
const listName = `${apiBase}s`;
const idField = `${apiBase}Id`;
const idsField = `${idField}s`;

const mapStateToProps = (state, ownProps) => {
  const newState = {};

  const userId = ownProps[idField]
    ? ownProps[idField]
    : _.get(ownProps, ["match", "params", idField]);

  newState[apiBase] = _.get(state.maps, [apiBase, userId]);

  newState[listName] = undefined;
  if (state.lists[idsField]) {
    newState[listName] = _.map(
      state.lists[idsField],
      (id) => state.maps[apiBase][id]
    );
  }

  if (
    state.timeClockPermission &&
    state.timeClockPermission.myTimeClockPermissionIds
  ) {
    newState.myTimeClockPermissions = _.map(
      state.timeClockPermission.myTimeClockPermissionIds,
      (id) => state.maps[apiBase][id]
    );
  }

  if (state.timeClockPermission.myCanViewUserIds) {
    newState.myCanViewUserIds = state.timeClockPermission.myCanViewUserIds;
  }

  if (state.timeClockPermission.myCanModifyUserIds) {
    newState.myCanModifyUserIds = state.timeClockPermission.myCanModifyUserIds;
  }

  newState.locationMap = state.maps.location;
  newState.userMap = state.maps.user;
  return newState;
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      searchTimeClockPermissions: search,
      getTimeClockPermission: get,
      addTimeClockPermission: add,
      updateTimeClockPermission: update,
      getMyTimeClockPermissions: getMine,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps);
